module.exports = __webpack_public_path__ + "static/media/210-grenada.ac4cc7e2.svg";